import { getGetOrganisationProjectFieldsQueryKey } from '@api/organisation-project-fields/organisation-project-fields'
import { Query, useQueryClient } from '@tanstack/react-query'

// Every project's field query (key of getGetProjectProjectFieldsQueryKey).
const PROJECT_FIELDS_KEY = /^\/projects\/[^/]+\/project-fields$/

const isProjectFieldsQuery = ({ queryKey }: Query) =>
  typeof queryKey[0] === 'string' && PROJECT_FIELDS_KEY.test(queryKey[0])

/** Refreshes the organisation's field definitions and every project form's copy of them. */
const useInvalidateProjectFields = () => {
  const queryClient = useQueryClient()

  return () =>
    Promise.all([
      queryClient.invalidateQueries(getGetOrganisationProjectFieldsQueryKey()),
      queryClient.invalidateQueries({ predicate: isProjectFieldsQuery }),
    ])
}

export default useInvalidateProjectFields
